import {Component, OnInit} from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-failed',
    templateUrl: './failed.component.html',
    styleUrls: ['./failed.component.scss']
})
export class FailedComponent implements OnInit {

    constructor() { }

    ngOnInit(): void { }

}